import React, { ReactNode, useContext, useEffect, useState } from 'react';

import OpsTeamHuddleContext from '@totem/components/ticketing/opsTeamHuddle/OpsTeamHuddleContext';
import { OpsHuddleDashboardResponse } from '@totem/components/ticketing/opsTeamHuddle/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { OPS_TEAM_HUDDLE_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const OpsTeamHuddleContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<OpsHuddleDashboardResponse | null>(null);
  const [refreshTick, setRefreshTick] = useState(0);

  useEffect(() => {
    setLoading(true);

    fetch(`${OPS_TEAM_HUDDLE_ENDPOINT}/dashboard`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: OpsHuddleDashboardResponse) => {
        setData(result);

        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [getApiToken, refreshTick]);

  const handleRefresh = () => setRefreshTick((prev) => prev + 1);

  return (
    <OpsTeamHuddleContext.Provider
      value={{ loading, data, onRefresh: handleRefresh }}
    >
      {children}
    </OpsTeamHuddleContext.Provider>
  );
};

export default OpsTeamHuddleContainer;
